import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
export function Slide4_SystemVisual() {
  return <SlideLayout className="!max-w-none !px-[150px]" data-id="element-106">
      <div className="flex flex-col h-full justify-center space-y-3" data-id="element-107">
        <motion.div className="text-center space-y-1" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-108">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white" data-id="element-109">
            The Complete System Architecture
          </h2>
          <p className="text-sm md:text-base text-slate-400" data-id="element-110">
            Visual breakdown of how every stage connects
          </p>
        </motion.div>

        <motion.div className="w-full bg-slate-900/30 rounded-xl border border-slate-800 p-2 shadow-2xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-111">
          <iframe style={{
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }} width="100%" height="100%" className="rounded-lg h-[70vh]" src="https://embed.figma.com/board/VXiMkf6fYlJy2cjipBFyEw/The-HIRE-Advantage?node-id=0-1&embed-host=share" allowFullScreen data-id="element-112" />
        </motion.div>
      </div>
    </SlideLayout>;
}